import React from 'react';

import { useCurrentUser } from '@klp/auth';
import { useGetByggKunderQuery } from '@klp/bygg/components/ByggKunder';
import { SakListComponent } from '@klp/sak/components/SakList';

interface IProps {
    byggNummer: string;
}

export const ByggSakList: React.FC<IProps> = ({ byggNummer }) => {
    const { isAdmin } = useCurrentUser();

    // RTK Query - prefetch byggKunder data when admin
    useGetByggKunderQuery({ byggNummer }, { skip: !isAdmin || !byggNummer });

    return <SakListComponent referrer="bygg" />;
};
